import BreakpointsEnum from "../enums/breakpointsEnum";
import 'lite-youtube-embed/src/lite-yt-embed.js';
import 'lite-youtube-embed/src/lite-yt-embed.css';

const $videoSlider = $('#videoSlider');
const $previewVideoSlider = $('#previewVideoSlider');

const initVideoSlider = function () {
    if ($previewVideoSlider.length && !$previewVideoSlider.hasClass('slick-initialized')) {
        $previewVideoSlider.on('click', 'img', function () {
            const $currentVideo = $videoSlider.find('.video.active');
            const index = $(this).attr('data-slick-index');

            if ($currentVideo.hasClass('youtube')) {
                $currentVideo.removeClass('lyt-activated active')
                    .find('iframe')
                    .remove();
            }

            if ($currentVideo.hasClass('vk')) {
                VK.VideoPlayer($currentVideo[0]).pause();
            }

            $currentVideo.removeClass('active');

            $videoSlider.find(`.video.video-${index}`)
                .addClass('active');
        });

        $previewVideoSlider.slick({
            slidesToShow: 3,
            arrows: false,
            dots: false,
            infinite: false,
            vertical: true,
            verticalSwiping: true,
            rows: 0,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1920,
                    settings: {
                        vertical: false,
                        verticalSwiping: false,
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 1280,
                    settings: {
                        vertical: false,
                        verticalSwiping: false,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: 'unslick'
                }
            ]
        });
    }
}

$(window).on('load resize orientationchange', function () {
    if (window.App.getBreakpoint() !== BreakpointsEnum.mobile) {
        initVideoSlider();
    }
});